import React from "react";
import CarouselShimmer from "../../ProductImageCarousel/carousel.shimmer";
import classNames from "classnames";
import styles from "./ProductShimmer.module.css";

const ProductShimmer = () => {
  return (
    <>
      <section className="prodetails mt-5">
        <div className="container">
          <div className="row ">
            <div className="col-md-5">
              <CarouselShimmer />
            </div>
            <div
              className={classNames("col-md-7", styles.detailsSection)}
            ></div>
          </div>
        </div>
      </section>
      <br />
      <hr className={styles.hr} />
      <br />
    </>
  );
};

export default ProductShimmer;
